/* Created by Interactive 63 - https://interactive63.com */
/**
 * In-memory interface preferences shared between panels, such as whether changing the scene
 * duration scales keyframes. Not saved with the project.
 */

export const preferences = {
  /** Scale keyframe times when the scene duration changes. */
  scaleKeyframes: true,
};
